module.exports = __webpack_public_path__ + "static/media/velocity-logo.48379628.png";